"use client"

import Link from "next/link"
import { useEffect } from "react"
import { captureClientException } from "@/shared/lib/monitoring/capture-client"

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureClientException(error, {
      scope: "client-render",
      extra: { digest: error.digest, boundary: "blog" },
    })
  }, [error])

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 text-center">
      <h1 className="text-2xl font-semibold text-foreground">
        Something went wrong
      </h1>

      <p className="mt-2 max-w-md text-muted-foreground">
        {error.message || "We couldn't load this page. Please try again."}
      </p>

      {error.digest && (
        <p className="mt-1 text-xs text-muted-foreground">
          Error ID: {error.digest}
        </p>
      )}

      <div className="mt-8 flex items-center gap-4">
        <button
          type="button"
          onClick={reset}
          className="rounded-full bg-primary px-5 py-2 text-sm font-medium text-primary-foreground transition hover:opacity-90"
        >
          Try again
        </button>
        <Link
          href="/blog"
          className="rounded-full border border-border px-5 py-2 text-sm font-medium text-foreground transition hover:bg-foreground/[0.06]"
        >
          Back to blog
        </Link>
      </div>
    </div>
  )
}
